import { Badge } from '@mantine/core'
import React from 'react'
import {
  COLOR_INTENT,
  FONT_SIZE,
  FONT_WEIGHT,
  LINE_HEIGHT,
  Z_INDEX,
} from 'Theme'

export const SouldOutBadge = () => (
  <Badge
    variant="filled"
    radius="4px"
    size="md"
    tt="initial"
    styles={() => ({
      root: {
        zIndex: Z_INDEX.SOLD_OUT_BADGE,
        fontSize: FONT_SIZE.PX_12,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: LINE_HEIGHT.S,
        color: COLOR_INTENT.COLLECTION_WIDGET_CARD.SOLD_OUT_BADGE.TEXT,
        backgroundColor:
          COLOR_INTENT.COLLECTION_WIDGET_CARD.SOLD_OUT_BADGE.BACKGROUND,
        padding: `0.25rem 0.625rem;`,
      },
    })}
  >
    Out of stock
  </Badge>
)
